var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"confirm-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFlag),expression:"showFlag"}],staticClass:"shade"},[_c('div',{staticClass:"loading-module-cont",style:({backgroundColor: _vm.textBgColor})},[_c('span',{staticClass:"loading-module-text",domProps:{"innerHTML":_vm._s(_vm.text)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }